import React from "react";
import nesaLogo from "../styles/resources/nesa_logo.png";

export default function LoginBanner() {
  return (
    <>
      <img src={nesaLogo} alt="NESA logo" height={200} />
    </>
  );
}
